import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-dsp-order",
  "use": "icon-dsp-order-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dsp-order\"><path d=\"M770.2 980.8H224.6c-50.4 0-91.3-41-91.3-91.4V155.6c0-50.4 41-91.4 91.3-91.4h545.6c50.4 0 91.3 41 91.3 91.4v733.8c0.1 50.4-40.9 91.4-91.3 91.4zM224.6 98.6c-31.4 0-56.9 25.5-56.9 56.9v733.8c0 31.4 25.5 57 56.9 57h545.6c31.4 0 56.9-25.6 56.9-57V155.6c0-31.4-25.5-56.9-56.9-56.9H224.6z\" fill=\"#E86262\" p-id=\"6032\" /><path d=\"M730.8 376.8H264c-9.5 0-17.2-7.7-17.2-17.2s7.7-17.2 17.2-17.2h466.8c9.5 0 17.2 7.7 17.2 17.2s-7.7 17.2-17.2 17.2zM714.3 539.7H264c-9.5 0-17.2-7.7-17.2-17.2s7.7-17.2 17.2-17.2h450.3c9.5 0 17.2 7.7 17.2 17.2s-7.8 17.2-17.2 17.2zM564.4 702.6H264c-9.5 0-17.2-7.7-17.2-17.2s7.7-17.2 17.2-17.2h300.4c9.5 0 17.2 7.7 17.2 17.2s-7.7 17.2-17.2 17.2z\" fill=\"#E86262\" p-id=\"6033\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/dsp-order.svg
// module id = rrFR
// module chunks = 118